/**
 * Data loader for Member Directory
 * Fetches active subscribers with CEO role from AccessType API
 */

import fetch from 'node-fetch';

export async function fetchMemberDirectoryData(accessTypeKey, accessTypeSubAuth, options = {}) {
  const { limit = 10, offset = 0, metadata, currentUserId } = options;

  if (!accessTypeKey) {
    throw new Error('AccessType API key is required');
  }

  // Construct the API URL with parameters
  const baseUrl = 'https://www.accesstype.com/api/access/v1/subscribers/active';
  const meta_data = JSON.stringify(metadata);

  const params = new URLSearchParams({
    key: accessTypeKey,
    metadata: meta_data,
    limit: limit.toString(),
    offset: offset.toString()
  });

  const apiUrl = `${baseUrl}?${params.toString()}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-SUBAUTH': accessTypeSubAuth,
      }
    });
    if (!response.ok) {
      throw new Error(`API request failed: ${response.status} ${response.statusText}`);
    }
    const { active_subscribers = [], total_count = 0 } = await response.json();
    // Transform the API response to match the expected member format
    const members = active_subscribers
      .filter(subscriber => {
        const { metadata: { other = {} } = {} } = subscriber;
        const optedShare = other['opted-share'];

        // Only include users who have opted to share (yes/Yes)
        if (!optedShare || (optedShare.toLowerCase() !== 'yes')) {
          return false;
        }

        // Filter out the currently logged-in user
        const { subscriber_identities = [] } = subscriber;
        const subObject = subscriber_identities.find(({ provider }) => provider === "quintype");
        return currentUserId ? subObject?.value != currentUserId : true;
      })
      .map(subscriber => {
        const { id, metadata: { other = {} } = {} } = subscriber;

        // Destructure metadata fields with fallbacks
        const {
          'first-name': firstName = '',
          'last-name': lastName = '',
          name = '',
          'designation': designation = '',
          'primary-role': primaryRole = '',
          organisation: company = '',
          location = '',
          region = '',
          email = '',
          phone = '',
          'profile-image': profileImage = null,
          'linkedin-url': linkedinUrl = null
        } = other;

        // Use designation if available, otherwise fallback to primary-role
        const title = designation || primaryRole;

        // Combine first-name and last-name, fallback to name field
        const combinedName = `${firstName} ${lastName}`.trim();

        return {
          id,
          name: combinedName || name,
          title,
          company,
          location,
          region,
          email,
          phone,
          profileImage,
          linkedinUrl
        };
      });

    return {
      members,
      totalCount: total_count || members.length,
      hasMore: (offset + limit) < total_count
    };
  } catch (error) {
    console.error('Error fetching member directory data:', error);
    throw error;
  }
}